// Piezas compartidas de Admin · Integración de planta.

import type { ReactNode } from 'react';
import { ApiError } from '../../../lib/api/client';

/** Mensajes legibles para los códigos 400/409 de admin_ingesta.ts. */
const MENSAJE_CODIGO: Record<string, string> = {
  golpes_min_aplica_activo:
    'La máquina no reporta golpes por minuto. Desactive «golpes/min aplica» en los SKUs de esta línea.',
  personas_estandar_faltante:
    'Las horas de máquina toman los operarios de «personas estándar por turno». Configúrelas en los SKUs de esta línea.',
  cadencia_no_soportada:
    'La captura por máquina solo aplica a líneas de producción con cadencia horaria estricta.',
  sin_usuario_tecnico: 'Primero cree el usuario técnico de la integración.',
  duplicate: 'Ya existe un mapeo con ese código externo.',
  invalid_refs: 'La referencia elegida no existe o no está activa.',
};

/**
 * Mensaje para el usuario: la explicación del código (si se conoce) más el
 * detalle del servidor, que ya viene en español (p. ej. los SKUs afectados).
 */
export function mensajeError(err: unknown): string {
  if (err instanceof ApiError) {
    const base = MENSAJE_CODIGO[err.code];
    if (!base) return err.message;
    // El servidor agrega la lista afectada tras «:» (p. ej. los SKUs).
    const i = err.message.indexOf(':');
    const detalle = i >= 0 ? err.message.slice(i + 1).trim() : '';
    return detalle ? `${base} Afectados: ${detalle}.` : base;
  }
  return err instanceof Error ? err.message : 'No pudimos completar la operación.';
}

export function Seccion({
  titulo,
  descripcion,
  accion,
  children,
}: {
  titulo: string;
  descripcion?: string;
  accion?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-3 rounded-md border border-border bg-surface-elevated p-4">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 max-w-xl">
          <h2 className="text-sm font-medium text-fg">{titulo}</h2>
          {descripcion ? (
            <p className="mt-0.5 text-[12px] leading-relaxed text-fg-tertiary">{descripcion}</p>
          ) : null}
        </div>
        {accion}
      </header>
      {children}
    </section>
  );
}
